<template>
  <StepCandidateInterviewSchedule2/>
</template>

<script setup>
import StepCandidateInterviewSchedule2 from "../components/StepCandidateInterviewSchedule2.vue";
import {useCandidateInterviewStore} from "../stores/CandidateInterviewStore.js";
import {useRoute} from "vue-router";

const route = useRoute();

const startTimeUnix = route.query.start_time;
const endTimeUnix = route.query.end_time;
const uuid = route.query.uuid;

const store = useCandidateInterviewStore();
store.load(uuid).then(() => {
  if (store.interview?.start_time && store.interview?.end_time) {
    return;
  }
  store.interview.start_time = new Date(startTimeUnix * 1000);
  store.interview.end_time = new Date(endTimeUnix * 1000);
});
</script>
